import GroupWiseLoanProposalActionTypes from './group-wise-loan-proposal.types';

/** ***************** CREATE GROUP WISE LOAN PROPOSAL START *********************** */
export const addGroupWiseLoanProposalStart = (addData: any) => ({
	type: GroupWiseLoanProposalActionTypes.ADD_GROUP_WISE_LOAN_PROPOSAL_START,
	payload: addData,
});

export const addGroupWiseLoanProposalSuccess = (successData: any) => ({
	type: GroupWiseLoanProposalActionTypes.ADD_GROUP_WISE_LOAN_PROPOSAL_SUCCESS,
	payload: successData,
});

export const addGroupWiseLoanProposalFailure = (failureData: any) => ({
	type: GroupWiseLoanProposalActionTypes.ADD_GROUP_WISE_LOAN_PROPOSAL_FAILURE,
	payload: failureData,
});

export const addGroupWiseLoanProposalResponseResetStart = () => ({
	type: GroupWiseLoanProposalActionTypes.ADD_GROUP_WISE_LOAN_PROPOSAL_RESPONSE_RESET,
});

export const addGroupWiseLoanProposalResponseChanged = () => ({
	type: GroupWiseLoanProposalActionTypes.ADD_GROUP_WISE_LOAN_PROPOSAL_RESPONSE_CHANGED,
});
/** ***************** CREATE GROUP WISE LOAN PROPOSAL END *********************** */

/** *****************   UPDATE GROUP WISE LOAN PROPOSAL START *********************** */
export const updateGroupWiseLoanProposalStart = (updateData: any) => ({
	type: GroupWiseLoanProposalActionTypes.UPDATE_GROUP_WISE_LOAN_PROPOSAL_START,
	payload: updateData,
});

export const updateGroupWiseLoanProposalSuccess = (successData: any) => ({
	type: GroupWiseLoanProposalActionTypes.UPDATE_GROUP_WISE_LOAN_PROPOSAL_SUCCESS,
	payload: successData,
});

export const updateGroupWiseLoanProposalFailure = (failureData: any) => ({
	type: GroupWiseLoanProposalActionTypes.UPDATE_GROUP_WISE_LOAN_PROPOSAL_RESPONSE_RESET,
	payload: failureData,
});

export const updateGroupWiseLoanProposalResponseResetStart = () => ({
	type: GroupWiseLoanProposalActionTypes.UPDATE_GROUP_WISE_LOAN_PROPOSAL_RESPONSE_RESET,
});

export const updateGroupWiseLoanProposalResponseChanged = () => ({
	type: GroupWiseLoanProposalActionTypes.UPDATE_GROUP_WISE_LOAN_PROPOSAL_RESPONSE_CHANGED,
});
/** ***************** UPDATE GROUP WISE LOAN PROPOSAL END *********************** */

// UNUSED ACTION
export const getSubGroupListStart = (fetchData: any) => ({
	type: GroupWiseLoanProposalActionTypes.GET_SUBGROUP_LIST_START,
	payload: fetchData,
});

export const getSubGroupListSuccess = (successData: any) => ({
	type: GroupWiseLoanProposalActionTypes.GET_SUBGROUP_LIST_SUCCESS,
	payload: successData,
});

export const getSubGroupListFailure = (failureData: any) => ({
	type: GroupWiseLoanProposalActionTypes.GET_SUBGROUP_LIST_FAILURE,
	payload: failureData,
});

export const getSubGroupListResponseResetStart = () => ({
	type: GroupWiseLoanProposalActionTypes.GET_SUBGROUP_LIST_RESPONSE_RESET,
});

export const getSubGroupListResponseChanged = () => ({
	type: GroupWiseLoanProposalActionTypes.GET_SUBGROUP_LIST_RESPONSE_CHANGED,
});
